// extracted by mini-css-extract-plugin
module.exports = {"page":"PageTransition_page__Z1tYz"};